<template>
  <v-container id="fcreate">
    <v-row>
      <v-col>
        <div class="text-h3" v-text="getCode" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-form v-model="valid" ref="form">
          <v-container fluid>
            <v-row>
              <!-- Название -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.code"
                  label="Код"
                  outlined
                  required
                  :rules="rules.required"
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <!-- Значение -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.value"
                  label="Значение"
                  outlined
                  required
                  :rules="rules.required"
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <!-- is JSON? -->
              <v-col cols="12" md="7">
                <v-checkbox
                  v-model="data.json"
                  label="is JSON?"
                  :loading="loading"
                  :disabled="loading"
                />
              </v-col>
              <!-- Сохранить -->
              <v-col cols="12" md="7">
                <v-btn
                  class="mb-2"
                  block
                  color="primary"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                  @click.prevent="save"
                >
                  Сохранить
                </v-btn>
                <v-btn
                  class="mb-2"
                  block
                  color="success"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                  @click.prevent="save(false)"
                >
                  Применить
                </v-btn>
                <v-btn
                  block
                  color="error"
                  :loading="loadingForm"
                  :disabled="loadingForm"
                  @click.prevent="$router('/settings/branches')"
                >
                  Отмена
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess">
      Измемнения сохранены
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import rules from '@/mixins/rules'

  export default {
    mixins: [rules],
    data () {
      return {
        data: {},
        edit: false,
        valid: false,
        loading: false,
        loadingForm: false,
        snackbar: false,
        snacbarSuccess: false,
      }
    },
    computed: {
      ...mapGetters({
        getSettingsSingle: 'branchesSettings/getSettingsSingle',
      }),
      getId () { return this.$route.params.id || null },
    },
    async created () {
      if (this.getId) {
        this.loading = true
        await this.$store
          .dispatch('branchesSettings/fetchSettingsSingle', this.getId)
          .then((res) => {
            if (res.status === 200) {
              this.loading = false
            }
          })

        this.edit = true
        this.data = this.getSettingsSingle
      } else {
        this.$router.push('/settings/branches')
      }
    },
    beforeDestroy () {
      this.$store.commit('branchesSettings/clearSettingsSingle')
    },
    methods: {
      async save (redirect = true) {
        const validate = await this.$refs.form.validate()

        if (validate) {
          this.loadingForm = true
          try {
            const res = await this.$store.dispatch('branchesSettings/editSettings', {
              data: this.data,
              id: this.getId,
            })

            if (res.status === 200 && redirect) {
              this.$router.push('/settings/branches')
            } else {
              this.snackbarSuccess = true
              setTimeout(() => {
                this.snackbarSuccess = false
              }, 3000)
            }
          } catch (e) { console.log(e) }

          this.loadingForm = false
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
    },
  }
</script>
